import State from 'interfaces/state/State';

export const avatar$ = (state: State) => state.avatar.avatar;
export const isLoading$ = (state: State) => state.avatar.isLoading;
export const isError$ = (state: State) => state.avatar.isError;
